export enum ResponseStyle {
    Brief = 'Brief',
    Detailed = 'Detailed',
}

export const isResponseStyle = (value: string): value is ResponseStyle =>
    (Object.values(ResponseStyle) as string[]).includes(value);

export interface UserPreferences {
    responseStyle: ResponseStyle;
    // Response-style nudge (#1563). Backend-driven eligibility; the popover on
    // RestyleButton reads these directly. Both fields are absent on legacy
    // responses so optional types keep the parsing forgiving.
    shouldShowResponseStyleNudge?: boolean;
    suggestedStyle?: ResponseStyle;
}

// Mirrors the C# `UpdatePreferencesRequest` record. The server only reads
// `responseStyle` on PUT /preferences/me; the nudge fields are server-computed
// and accepting them on the request type would let callers send fields that
// are silently dropped.
export interface UpdatePreferencesRequest {
    responseStyle: ResponseStyle;
}

// Initial Redux value before GET /preferences/me resolves. Brief mirrors the
// backend's flag-gated default; the server's value overwrites this once fetched,
// and the response-length UI is gated on ResponseStylePreferenceEnabled anyway.
export const defaultUserPreferences: UserPreferences = {
    responseStyle: ResponseStyle.Brief,
    shouldShowResponseStyleNudge: false,
    suggestedStyle: undefined,
};
